import { MenuItem } from '@mui/material';
import React from 'react';

import { FormikTextField } from '../formik-text-field';

export type FormikSelectOption = {
  id: number | string;
  name: string;
};

type Props = Omit<React.ComponentProps<typeof FormikTextField>, 'select'> & {
  options?: FormikSelectOption[];
};

const FormikSelectField: React.FC<Props> = ({ disabled, options, ...props }: Props) => {
  return (
    <>
      {options && (
        <FormikTextField {...props} select disabled={disabled || options.length === 0}>
          {options.map((option) => {
            return (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            );
          })}
        </FormikTextField>
      )}
    </>
  );
};

export { FormikSelectField };
